import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const Lightbox = ({ image, onClose }) => (
  <AnimatePresence>
    {image && (
      <motion.div
        className="pf-lightbox"
        role="dialog"
        aria-modal="true"
        aria-label="Gallery photo"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.22 }}
        onClick={onClose}
      >
        <button className="pf-lightbox-close" onClick={onClose} aria-label="Close gallery photo">✕</button>
        <motion.img
          src={image}
          alt="Gallery view"
          initial={{ scale: 0.88, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.88, opacity: 0 }}
          transition={{ duration: 0.22 }}
          onClick={(e) => e.stopPropagation()}
        />
      </motion.div>
    )}
  </AnimatePresence>
);
